import React, { useState, useEffect } from 'react';
import Grid from '@material-ui/core/Grid';
import SaveIcon from '@material-ui/icons/Save';
import CloseIcon from '@material-ui/icons/Close';
import { Formik, Form } from 'formik';
import * as Yup from 'yup';
import BiztranControls from "../../biztran_controls/BiztranControls";
import BiztranControlsFormik from "../../biztran_controls_formik/BiztranControlsFormik";
import UseFetchData from "../../../hooks/UseFetchData";

const CreateDAPolicy = (props) => {
    const [DAPolicyID, setDAPolicyID] = useState('');
    const [CategoryID, setCategoryID] = useState('');
    const [DACapitalCities, setDACapitalCities] = useState('');
    const [DANonCapitalCities, setDANonCapitalCities] = useState('');
    const [DAOwnArrangement, setDAOwnArrangement] = useState('');
    const [Countrycmb, setCountrycmb] = useState([]);
    const [response, fetchData] = UseFetchData();
    const [responseCombo, fetchComboData] = UseFetchData();
    const [responseGetData, fetchGetData] = UseFetchData();
    const [Categorycmb, setCategorycmb] = useState([]);
    const [CategoryDataResponse, fetchCategoryData] = UseFetchData();
    // const validationSchema = Yup.object({
    //     CountryID:Yup.string().required('Required!'),
    //     StateName:Yup.string().required('Required!'),
    //     StateCode:Yup.string().required('Required!'),
    // });

    const onSubmit = values => {
        var bodyFormData = new FormData();
        bodyFormData.append("Type", 'DA Policy');
        bodyFormData.append("PKID", props.PKID);
        bodyFormData.append("Value1", values.CategoryID);
        bodyFormData.append("Value2", values.DACapitalCities);
        bodyFormData.append("Value3", values.DANonCapitalCities);
        bodyFormData.append("Value4", values.DAOwnArrangement);
        fetchData("Primary/Save", bodyFormData);
    };

    const getByIDData = () => {
        var bodyFormData = new FormData();
        bodyFormData.append("Type", 'DA Policy');
        bodyFormData.append("PKID", props.PKID);
        fetchGetData("Primary/GetByID", bodyFormData);
    }


    const PopulateCategorydata = () => {
        var bodyFormData = new FormData();
        fetchCategoryData("Primary/ComboData", bodyFormData);
    }
    const CategoryData = (options) => {
        debugger;
        if (options !== undefined) {
            let Category = options.map((data) => (
                <option key={data.Category} value={data.CategoryID}>
                    {data.Category}
                </option>
            ));
            setCategorycmb(Category);
        }
    };

    useEffect(() => {
        debugger;
        if (CategoryDataResponse !== undefined) {
            if (CategoryDataResponse["Category"] !== undefined) {
                CategoryData(CategoryDataResponse["Category"]);
            }
        }
    }, [CategoryDataResponse]);

    useEffect(() => {
        PopulateCategorydata();
        // HotelStarRating();
        // ModeOfTravelType();
    }, [])

    // const CountryData = () => {
    //     var bodyFormData = new FormData();
    //     bodyFormData.append("Type", 'Country');
    //     fetchComboData("Primary/List", bodyFormData);
    // }

    // const CountrydataOpt = (CountryOption) => {
    //     let CountryCombo = CountryOption.map((data) =>
    //         <option
    //             key={data.Country}
    //             value={data.id}
    //         >
    //             {data.Country}
    //         </option>
    //     );
    //     setCountrycmb(CountryCombo);
    // };

    useEffect(() => {
        if (response.Response === true) {
            props.setOpen(false);
            props.PopulateData();
            alert('Saved Succesfully.')
        }
        else if (response.Response === false) {
            alert('Save Failed.')
        }
    }, [response])

    // useEffect(() => {
    //     CountrydataOpt(responseCombo);
    // },[responseCombo])

    useEffect(() => {
        if (responseGetData.length > 0) {
            setDAPolicyID(responseGetData[0].DAPolicyID);
            setCategoryID(responseGetData[0].CategoryID);
            setDACapitalCities(responseGetData[0].DACapitalCities);
            setDANonCapitalCities(responseGetData[0].DANonCapitalCities);
            setDAOwnArrangement(responseGetData[0].DAOwnArrangement);
        }
    }, [responseGetData])

    useEffect(() => {
        // CountryData();
        if (props.PKID !== '') {
            getByIDData();
        }
    }, [])

    return (
        <div>
            <Formik initialValues={{
                CategoryID: CategoryID, DAPolicyID: DAPolicyID, DACapitalCities: DACapitalCities, DANonCapitalCities: DANonCapitalCities,
                DAOwnArrangement: DAOwnArrangement
            }}
                // validationSchema = {validationSchema} 
                onSubmit={onSubmit} enableReinitialize>
                {formik => {
                    return <Form>
                        <Grid spacing={2} container>
                            {/* <Grid item xs={12}>
                                <BiztranControlsFormik 
                                    control='select' 
                                    label='Travelling Policy Type' 
                                    name='CountryID'
                                    options={Countrycmb} 
                                    onChange={(e) => setCountryID(e.target.value)}
                                />
                            </Grid> */}
                            <Grid item xs={12}>
                                <BiztranControlsFormik
                                    control='select'
                                    type='text'
                                    label='Category'
                                    name='CategoryID'
                                    options={Categorycmb}
                                    onChange={(e) => setCategoryID(e.target.value)}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <BiztranControlsFormik
                                    control='input'
                                    type='text'
                                    label='DA Capital Cities'
                                    name='DACapitalCities'
                                    onChange={(e) => setDACapitalCities(e.target.value)}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <BiztranControlsFormik
                                    control='input'
                                    type='text'
                                    label='DA Non Capital Cities'
                                    name='DANonCapitalCities'
                                    onChange={(e) => setDANonCapitalCities(e.target.value)}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <BiztranControlsFormik
                                    control='input'
                                    type='text'
                                    label='DA Own Arrangement'
                                    name='DAOwnArrangement'
                                    onChange={(e) => setDAOwnArrangement(e.target.value)}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <div style={{ width: '100%' }}>
                                    <div style={{ display: 'flex', justifyContent: 'center', alignContent: "center" }}>
                                        <BiztranControls.Button
                                            text="SAVE"
                                            type="submit"
                                            startIcon={<SaveIcon />}
                                        />
                                        <BiztranControls.Button
                                            text="CLOSE"
                                            startIcon={<CloseIcon />}
                                            onClick={() => { props.setOpen(false); }}
                                        />
                                    </div>
                                </div>
                            </Grid>
                        </Grid>
                    </Form>
                }}
            </Formik>
        </div>
    );
}

export default CreateDAPolicy;
